const Animal = {
    animal: {
        animal: 'Animal',
        animals: 'Animales',
        add: 'Añadir animal',
        first: 'No has añadido ningún animal aún, por favor añade algún animal para empezar.',
        mother: 'Madre',
        father: 'Padre',
        name: 'Nombre',
        owner: 'Propietario',
        description: 'Descripción',
        birthDate: 'Fecha de nacimiento',
        age: 'Edad',
        reference: 'Referencia',
        externalId: 'Número de registro oficial (DIB, Crotal, ...)',
        internalId: 'Identificador secundario (nombre, alias, referencia, ...)',
        land: 'Finca',
        datas: {
            title: 'Estado del animal'
        },
        gender: 'Género',
        genders: {
            male: 'Macho',
            female: 'Hembra',
            males: 'Machos',
            females: 'Hembras'
        },
        deliver: 'Parto',
        delivers: {
            first: 'Primer parto',
            analisys: 'Análisis de partos',
            average: 'Un parto cada {{days}} días',
            table: 'Tabla de partos',
            graphic: 'Gráfica de partos'
        },
        health: 'Salud',
        healthy: {
            title: 'Saludable',
            data: 'Datos Sanitarios',
            vaccines: 'Vacunas',
            diseases: 'Enfermedades',
            diseasesTable: 'Tabla de enfermedades',
            veterinary: 'Veterinario'
        },
        children: 'Crias',
        childrens: {
            title: 'Crias',
            amount: 'Cantidad'
        },
        type: 'Tipo',
        types: {
            adult: 'Adulto',
            child: 'Cria',
            group: 'Camada'
        },
        specie: 'Especie',
        species: {
            bovine: 'Bovino',
            goat: 'Caprino',
            equine: 'Equino',
            ovine: 'Ovino',
            porcine: 'Porcino',
            canine: 'Canino'
        },
        state: 'Estado',
        states: {
            pregnancy: 'Embarazada',
            breeding: 'Crianza',
            maintenance: 'Mantenimiento',
            growing: 'Crecimiento',
            fattening: 'Engorde',
            ready: 'Preparado',
            sold: 'Vendido'
        },
        bovine: {
            adult: {
                male: 'Toro',
                male_other: 'Toros',
                female: 'Vaca',
                female_other: 'Vacas'
            },
            child: {
                male: 'Ternero',
                male_other: 'Terneros',
                female: 'Ternera',
                female_other: 'Terneras'
            }
        },
        porcine: {
            adult: {
                male: 'Cerdo',
                male_other: 'Cerdos',
                female: 'Cerda',
                female_other: 'Cerdas'
            },
            group: {
                default: 'Lechon',
                default_other: 'Lechones',
                male: 'Lechones',
                female: 'Lechonas'
            }
        }
    }
};

export default Animal;
